var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNoData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 114.601,
    height: 152.802,
    viewBox: "0 0 114.601 152.802",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Exclusion_1",
    "data-name": "Exclusion 1",
    d: "M107.438,152.8H7.163A7.172,7.172,0,0,1,0,145.638V7.163A7.172,7.172,0,0,1,7.163,0H66.852V40.588a7.17,7.17,0,0,0,7.161,7.163H114.6v97.886A7.172,7.172,0,0,1,107.438,152.8ZM57.3,99.514a27.182,27.182,0,0,1,23.077,12.7l1.5-.007a27.326,27.326,0,0,0-49.159.007h1.5A27.2,27.2,0,0,1,57.3,99.514Zm17.507-30.4a7.5,7.5,0,0,0,0,15.007,7.373,7.373,0,0,0,7.5-7.5A7.339,7.339,0,0,0,74.807,69.114Zm-35.016,0a7.561,7.561,0,1,0,7.5,7.5A7.339,7.339,0,0,0,39.791,69.114ZM114.6,38.2H76.4V0h1.821A7.122,7.122,0,0,1,83.3,2.09l29.216,29.247a7.172,7.172,0,0,1,2.09,5.042V38.2Z",
    fill: "#007bc6",
    opacity: 0.998
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoData);
export default __webpack_public_path__ + "static/media/no_data.5370909d0ffed1f87b4900ce5a1fd4ac.svg";
export { ForwardRef as ReactComponent };